export default 'M12,22 C6.47988636,22 2,17.5201136 2,12 C2,6.47988636 6.47988636,2 12,2 C17.5201136,2 22,6.47988636 22,12 C22,17.5201136 17.5201136,22 12,22';
